export default __webpack_public_path__ + "static/media/cpf-member.fd8f9519.jpeg";